import { Search } from "lucide-react";

export default function SearchInput({ value, onChange, placeholder = "Search…", testId }) {
  return (
    <div className="relative">
      <Search className="absolute left-2 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        data-testid={testId}
        className="h-8 w-64 pl-8 pr-2 text-sm rounded-sm border border-input bg-transparent focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
      />
    </div>
  );
}
